import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';

export const PayerColumns = [
    {
        title: 'Approved Payer name',
        name: 'payerName',
        class: 'no-upscope',
        width: '130px'
    },
    {
        title: 'Account number/IBAN',
        name: 'accountNumberIban',
        class: 'no-upscope',
        width: '280px'
    },
    {
        title: 'Bank country',
        name: 'bankCountry',
        width: '130px'
    },
    {
        title: 'Currency',
        name: 'currency',
        width: '95px'
    },
    {
        title: 'Updated by',
        name: 'updatedBy',
        width: '120px'
    },
    {
        title: 'Last updated date',
        name: 'lastUpdatedDate',
        type: TableCellTypes.Date,
        width: '150px'
    }
];
